import React, { useState, useRef, useEffect } from "react";
import {
  createStoreOnline,
  deleteStoreOnline,
  getStoreOnlineAll,
  updateStoreOnline,
  softDeleteStoreOnline,
} from "../../Services/StoreOnlineService";
import { getCountryAll } from "../../Services/CountryService";
import { useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import MTable from "../../Components/MTable/MTable";
import { InputSwitch } from "primereact/inputswitch";
import Overlay from "../../Components/Overlay/Overlay";
import { handlerFormError, uuid } from "../../Utils/Utils";
import { toastError, toastSuccess } from "../../Components/Toasts/Toast";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import EditButton from "../../Components/Button/EditButton";
import DeleteButton from "../../Components/Button/DeleteButton";

let processingId = -1;

const StoreOnlinePage = () => {
  let { userInfo } = useSelector((state) => state.auth);
  const [showAll, setShowAll] = useState(false);
  const mTable = useRef();
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      store_code: "",
      store_name: "",
      link: "",
      is_active: true,
      is_show: 0,
      country_code: "",
    },
  });
  const [state, setState] = useState({
    showForm: false,
    olstore: {
      store_code: "",
      store_name: "",
      link: "",
      is_active: true,
      is_show: 0,
      country_code: "",
    },
    countries: [],
    processing: false,
  });

  const onActiveChange = (item) => (e) => {
    if (!userInfo.access.master_store_onlune.can_update) {
      toastError("You dont have permission for this action");
      return;
    }
    const status = e.target.value ? "Activate" : "Inactive";
    softDeleteStoreOnline(item.id, { is_active: e.target.value })
      .then((res) => {
        toastSuccess(`${status} ${item.store_name} Success.`);
        mTable.current.refresh();
      })
      .catch(({ response: { err } }) => {
        toastError(`${status} Failed.`);
      });
  };

  const columns = [
    { id: uuid(), title: "Store Name", field: "store_name", sortable: true },
    { id: uuid(), title: "Store Code", field: "store_code", sortable: true },
    {
      id: uuid(),
      title: "Url",
      field: "link",
      sortable: true,
      style: {
        overflow: `hidden`,
        textOverflow: `ellipsis`,
        width: 250,
      },
    },
    {
      id: uuid(),
      title: "Country Code",
      field: "country_code",
      sortable: true,
    },
    {
      id: uuid(),
      title: "Active",
      field: "is_active",
      render: (item) => {
        if (item.is_active === true) {
          return <span className="badge badge-success">Active</span>;
        } else {
          return <span className="badge badge-secondary">Inactive</span>;
        }
      },
    },
    {
      id: uuid(),
      title: "",
      sortable: true,
      style: { width: 200 },
      render: (item) => {
        return (
          <div>
            {userInfo.access.master_store_onlune.can_update && (
              <EditButton title="Edit" onClick={onEdit(item)} />
            )}
            {userInfo.access.master_store_onlune.can_delete && (
              <DeleteButton title="Remove" onClick={onRemove(item)} />
            )}
          </div>
        );
      },
    },
  ];

  const showAllFunc = () => {
    setShowAll(!showAll);
    mTable.current.refresh();
  };

  const propsTable = {
    columns,
    showAllState: showAll,
    showAllFunc,
    getData: (params) => {
      if (showAll === false) {
        if (params.filterAnd) params.filterAnd += "," + `is_active:true`;
        else params.filterAnd = "is_active:true";
      }
      return getStoreOnlineAll({ ...params });
    },
    enableFilter: true,
    showAddButton: !userInfo.access.master_store_onlune.can_create
      ? false
      : true,
  };

  const removeData = (id) => {
    deleteStoreOnline(
      id,
      (res) => {
        if (res.status == 200 || res.status == 201) {
          Swal.fire({
            icon: "success",
            title: "Delete data success",
            text: "Data has been deleted!",
          }).then((res) => {
            mTable.current.refresh();
          });
        }
      },
      ({ response: { data } }) => {
        Swal.fire({
          icon: "error",
          title: "Delete data fail",
          text: data.message,
        });
      }
    );
  };

  const onEdit = (item) => () => {
    if (!userInfo.access.master_store_onlune.can_update) {
      return;
    }
    reset(item);
    setState({ ...state, olstore: item, showForm: true });
  };

  const onRemove = (item) => () => {
    if (!userInfo.access.master_store_onlune.can_delete) {
      toastError("You dont have permission for this action");
      return;
    }

    Swal.fire({
      icon: "question",
      title: "Are you sure?",
      text: "Deleted data can not be restored!",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        removeData(item.id);
      }
    });
  };

  const onAddData = () => {
    if (!userInfo.access.master_store_onlune.can_create) {
      return;
    }
    onReset();
    setState({ ...state, showForm: true });
  };

  const startProcessing = () => {
    processingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  };

  const stopProcessing = () => {
    clearTimeout(processingId);
    setState({ ...state, processing: false });
  };

  const onSubmit = (data) => {
    startProcessing();
    const response = olstore.id
      ? updateStoreOnline(olstore.id, data)
      : createStoreOnline(data);
    response
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          Swal.fire({
            icon: "success",
            title: "Save data success",
            text: "Data has been saved!",
          }).then((r) => {
            mTable.current.refresh();
            olstore.id ? onCloseForm() : onReset();
          });
        }
      })
      .catch(({ response: { data } }) => {
        handlerFormError(data);
      })
      .finally((_) => stopProcessing());
  };

  const onReset = () => {
    reset({
      store_code: "",
      store_name: "",
      link: "",
      is_active: true,
      is_show: 0,
      country_code: "",
    });
    setState({ ...state, olstore: {} });
  };

  const onCloseForm = () => {
    reset({
      store_code: "",
      store_name: "",
      link: "",
      is_active: true,
      is_show: 0,
      country_code: "",
    });
    setState({ ...state, olstore: {}, showForm: false });
  };

  useEffect(() => {
    getCountryAll({ orders: "country_name:asc", perpage: 1000 }, ({ data }) => {
      setState({ ...state, countries: data.data });
    });
  }, []);

  const { olstore, processing, showForm } = state;

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h4
                style={{
                  marginTop: "0.5rem",
                  marginLeft: "0.2rem",
                  fontWeight: "400",
                }}
              >
                {showForm ? "Online Store Form" : "Online Store Management"}
              </h4>
              <h6
                style={{
                  marginLeft: "0.2rem",
                  fontWeight: "200",
                  letterSpacing: "1.2px",
                }}
              >
                {showForm
                  ? "Add/edit a online store"
                  : "Database of online stores"}
              </h6>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <NavLink to="/home">Home</NavLink>
                </li>
                <li className="breadcrumb-item active">Store</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <Overlay display={processing} />

                <form name="form-detail" onSubmit={handleSubmit(onSubmit)}>
                  <div className="card-body">
                    <div
                      className={`${
                        !showForm
                          ? "card__side--front-show"
                          : "card__side--front"
                      }`}
                    >
                      <MTable
                        ref={mTable}
                        {...propsTable}
                        onAddData={onAddData}
                        showIndex={true}
                      />
                    </div>

                    <div
                      className={`${
                        showForm ? "card__side--back-show" : "card__side--back"
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="store_code">Store Code</label>
                            <input
                              id="store_code"
                              {...register("store_code", {
                                required: {
                                  value: true,
                                  message: "Store code is required!",
                                },
                              })}
                              placeholder="Store code"
                              className="form-control"
                            />
                            {errors.store_code && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.store_code.message}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <label htmlFor="store_name">Store Name</label>
                            <input
                              id="store_name"
                              {...register("store_name", {
                                required: {
                                  value: true,
                                  message: "Store name is required!",
                                },
                              })}
                              placeholder="Store name"
                              className="form-control"
                            />
                            {errors.store_name && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.store_name.message}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <label htmlFor="link">URL</label>
                            <input
                              id="link"
                              {...register("link", {
                                required: {
                                  value: true,
                                  message: "Segment link is required!",
                                },
                              })}
                              placeholder="Segment initials"
                              className="form-control"
                            />
                            {errors.link && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.link.message}
                              </span>
                            )}
                          </div>
                          <div className="form-group">
                            <label htmlFor="country_code">Country</label>
                            <select
                              id="country_code"
                              className="form-control"
                              {...register("country_code", {
                                required: {
                                  value: true,
                                  message: "Country is required!",
                                },
                              })}
                            >
                              <option value={""}>Select Country</option>
                              {state.countries.map((seg, i) => (
                                <option
                                  key={`ctg-` + i}
                                  value={seg.country_code}
                                >
                                  {seg.country_name}
                                </option>
                              ))}
                            </select>
                            {errors.country_code && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.country_code.message}
                              </span>
                            )}
                          </div>

                          <div className="form-group">
                            <label htmlFor="is_show">Show on Product</label>
                            <div>
                              <Controller
                                name="is_show"
                                control={control}
                                render={({ field }) => {
                                  return (
                                    <InputSwitch
                                      {...field}
                                      checked={field.value}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>

                          <div className="form-group">
                            <label htmlFor="is_active">Active</label>
                            <div>
                              <Controller
                                name="is_active"
                                control={control}
                                render={({ field }) => {
                                  return (
                                    <InputSwitch
                                      {...field}
                                      checked={field.value}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {showForm && (
                    <div className="card-footer delay">
                      <div className="row">
                        <div className="col-md-12">
                          <div
                            className="d-flex"
                            style={{ justifyContent: "flex-end" }}
                          >
                            <button
                              type="button"
                              className="btn btn-default mr-3"
                              style={{ width: 100 }}
                              onClick={onCloseForm}
                            >
                              <i className="fa fa-times" /> Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger mr-3"
                              style={{ width: 100 }}
                              onClick={onReset}
                            >
                              <i className="fa fa-sync" /> Clear
                            </button>
                            <button
                              type="submit"
                              className="btn btn-dark"
                              style={{ width: 100 }}
                              disabled={
                                control._formValues.id
                                  ? !userInfo.access.master_store_onlune
                                      .can_update
                                  : !userInfo.access.master_store_onlune
                                      .can_create
                              }
                            >
                              <i className="fa fa-save" /> Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StoreOnlinePage;
